import { cn } from '@/lib/utils';
import {
  STOCK_STATUS_LABELS,
  describeStockStatus,
  getStockStatus,
  type StockStatus,
  type StockStatusInput,
} from '@/features/inventory/stockStatus';

// Problems are solid so they stand out while scrolling; healthy and
// overstock are soft tints so they don't compete with the alerts.
const STATUS_CLASSES: Record<StockStatus, string> = {
  out: 'border-transparent bg-red-600 text-white',
  low: 'border-transparent bg-orange-500 text-white',
  in_transit: 'border-transparent bg-yellow-300 text-yellow-950',
  in_stock: 'border-green-300 bg-green-100 text-green-800',
  overstock: 'border-orange-300 bg-orange-100 text-orange-800',
};

export function StockStatusBadge({
  input,
  uom,
  className,
}: {
  input: StockStatusInput | null | undefined;
  uom: string;
  className?: string;
}) {
  const status = input ? getStockStatus(input) : null;
  if (!input || !status) return null;
  return (
    <span
      title={describeStockStatus(input, uom)}
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium',
        STATUS_CLASSES[status],
        className,
      )}
    >
      {STOCK_STATUS_LABELS[status]}
    </span>
  );
}
